"use client";

import { FornecedorComboboxItem } from "@apiInclui/fornecedor";
import { IconBriefcase2Filled } from "@tabler/icons-react";
import { Badge, fmt, Loader } from "visuais";
import { DialogSearch } from "@PN/_nucleo";
import { useMemo } from "react";
import {
  useFornecedorDialog,
  FornecedorContentDialog,
  TriggerCard,
} from "@PN/inclusao";
export function FornecedorDialog() {
  const {
    open,
    term,
    hasUserTyped,
    isLoading,
    searchError,
    options,
    buttonLabel,
    selectedItem,
    handleSelectSupplier,
    handleKeyDown,
    handleInputChange,
    handleOpenChange,
    isItemSelected,
  } = useFornecedorDialog();

  const selectedLabel = useMemo(() => {
    return selectedItem?.nome || "Selecionar";
  }, [selectedItem]);

  const trigger = (
    <TriggerCard
      icon={
        <IconBriefcase2Filled className="size-4 text-cyan-600 dark:text-cyan-400" />
      }
      label="Fornecedor"
      isValid={!!selectedItem}
    >
      {/* Informações do fornecedor */}
      {selectedItem ? (
        <>
          <div className="flex items-center justify-between gap-1">
            {/* Código e Loja */}
            <Badge
              variant="secondary"
              className="flex items-center gap-1 text-[7pt]"
            >
              <span>{selectedItem.cod}</span>
              <span className="text-cyan-500">•</span>
              <span>{selectedItem.loja}</span>
            </Badge>
            {/* CNPJ se disponível */}
            {selectedItem.cnpj && (
              <Badge
                variant="secondary"
                className="flex items-center gap-2 text-[7pt]"
              >
                {fmt.strings.cnpj(selectedItem.cnpj)}
              </Badge>
            )}
          </div>
          {/* Nome principal */}
          <p
            className="text-base uppercase text-center font-semibold text-cyan-800 dark:text-cyan-200 truncate"
            title={selectedItem.nome}
          >
            {selectedItem.nome}
          </p>
          {/* Informações adicionais na parte de baixo */}
          {selectedItem.endereco && (
            <div className="flex items-center justify-center gap-1">
              <span className="text-[8pt] text-slate-600 dark:text-slate-400 truncate">
                {selectedItem.endereco}
                {selectedItem.municipio && `, ${selectedItem.municipio}`}
                {selectedItem.estado && ` - ${selectedItem.estado}`}
              </span>
            </div>
          )}
        </>
      ) : (
        <p className="text-base uppercase font-semibold text-cyan-800 dark:text-cyan-200 text-center">
          {selectedLabel}
        </p>
      )}
    </TriggerCard>
  );

  return (
    <div className="h-full">
      <DialogSearch<FornecedorComboboxItem>
        open={open}
        onOpenChange={handleOpenChange}
        term={term}
        onTermChange={handleInputChange}
        onKeyDown={handleKeyDown}
        options={options}
        isLoading={isLoading}
        hasUserTyped={hasUserTyped}
        searchError={searchError}
        label={buttonLabel}
        disabled={false}
        buttonIcon={
          isLoading ? (
            <Loader className="size-5" />
          ) : (
            <IconBriefcase2Filled className="size-5 text-muted-foreground" />
          )
        }
        buttonClassName="text-[8pt]"
        placeholder="Busque o fornecedor para esta pré-nota..."
        current={selectedItem}
        onSelect={handleSelectSupplier}
        groupLabel={(opts) => `${opts.length} fornecedor(es) encontrado(s)`}
        dialogClassName="min-w-[40vw] min-h-[50vh]"
        maxItems={8}
        enableVirtualization={true}
        virtualizationConfig={{
          estimateSize: 140,
          overscan: 3,
          initialHeight: 500,
        }}
        trigger={trigger}
      >
        {(opt) => (
          <FornecedorContentDialog opt={opt} isSelected={isItemSelected(opt)} />
        )}
      </DialogSearch>
    </div>
  );
}
